import React, {useState, useEffect} from 'react';
import './Sidebar.css';
import { Avatar } from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import {logout, selectUser} from './features/userSlice';
import {auth} from './firebase';
import {db} from './firebase';
import { Link} from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';
import HomeIcon from '@material-ui/icons/Home';
import ChatIcon from '@material-ui/icons/Chat';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import SidebarChannel from './SidebarChannel';
import HeaderOption from './HeaderOption';


function Sidebar() {
    const user = useSelector(selectUser);
    const dispatch = useDispatch();
    const logoutOfApp = () => {
    dispatch(logout())
    auth.signOut();
    }

    const [channels, setChannels] = useState([]);

    useEffect(() => {
    db.collection("channels").onSnapshot((snapshot) => 
        setChannels(
            snapshot.docs.map((doc) => ({
                id: doc.id,
                channel: doc.data(),
            }))
        )
    );
}, []);

    const handleAddChannel = () => {
    const channelName = prompt("Enter a New channel name");
    
    if(channelName) {
        db.collection("channels").add({
            channelName: channelName,
        });
    }
    };

    return (
    <div className="sidebar">
        <div className="sidebar__top">
            <img src="https://i.imgur.com/tIVv6CD.jpg" alt=""/>
            <Avatar 
            src={user.photoUrl} 
            className="sidebar__avatar" 
            onClick={logoutOfApp}>{user.email[0]}
            </Avatar>
            <h2>{user.displayName}</h2>
            <h4>{user.email}</h4>
        </div>
      
        <div className="sidebar__stats">
           
            <Link to="/" exact style={{textDecoration: 'none'}}>
                <HeaderOption Icon={HomeIcon} title='Home'/>
            </Link>  
           
            <Link to="/chat" exact style={{textDecoration: 'none'}}>
                <HeaderOption Icon={ChatIcon} title='#Channels'/>
            </Link>  
            <Link to="/news" exact style={{textDecoration: 'none'}}>
                <HeaderOption Icon={AnnouncementIcon} title='#News'/>
            </Link> 
        </div>
       
        <div className="sidebar__channels">
                <div className="sidebar__channelsHeader">
                    <div className="sidebar__header">
                        {/*<ExpandMoreIcon/>
                        <h4>CO+LABORAR Channels</h4>*/ }
                        <h4># CHANNELS</h4>
                    </div>

                    <AddIcon onClick={handleAddChannel}className='sidebar__addChannel' />
                </div>
                <div className="sidebar__channelsList">
                <Link to="/chat" exact style={{textDecoration: 'none'}}>
                    {channels.map(({id, channel}) => (
                        <SidebarChannel
                        key={id}
                        id={id}
                        channelName={channel.channelName}
                        />
                    ))}
                </Link>
                </div>
        </div>
    </div>
    
    ) ;
}

export default Sidebar;
/*
 <div className="sidebar__stat">
                <p></p>
                <p className="sidebar__statNumber"></p>
        
            </div>
            <div className="sidebar__stat">
                <p></p>
                <p className="sidebar__statNumber"></p>
            </div> */